// Debug utilities for authentication issues

export const clearAllAuthState = () => {
  console.log('🧹 Clearing all authentication state...')
  
  // Clear localStorage
  localStorage.clear()
  
  // Clear sessionStorage 
  sessionStorage.clear()
  
  // Clear cookies by setting them to expire
  document.cookie.split(";").forEach((c) => {
    const eqPos = c.indexOf("=")
    const name = eqPos > -1 ? c.substr(0, eqPos) : c
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/"
  })
  
  console.log('✅ All auth state cleared')
}

export const debugCurrentState = () => {
  console.log('🔍 Current Auth Debug State:', {
    url: window.location.href,
    pathname: window.location.pathname,
    localStorage: { ...localStorage },
    sessionStorage: { ...sessionStorage },
    cookies: document.cookie,
    timestamp: new Date().toISOString()
  })
}

// Add to window for easy debugging
if (typeof window !== 'undefined') {
  (window as any).debugAuth = {
    clearAllAuthState,
    debugCurrentState,
    reloadPage: () => window.location.reload()
  }
}